import { query } from "firebase/database";
import {
  addDoc,
  collection,
  doc,
  getDocs,
  serverTimestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import homeImageBackground from "../assets/images/homeBackground.png";
import { auth, firestoredDB, saveImageToStorage } from "../config/firebase";
import { clearInstructions } from "../redux/instructions";
import {
  clearTitle,
  emptyRecipeAllImageByDishNumber,
  resetImageGenerationCount,
  setDishImage,
} from "../redux/title";
import { decreamentRecipeTokens } from "../redux/tokens";
import { updateUserTokens } from "../utils/updateTokens";
import AddToCookbookModal from "./alerts/AddToCookbookModal";
import GenerateImageRecipe from "./open-ai/GenerateImageRecipe";
import GenerateInstructions from "./open-ai/GenerateInstructions";
import { playAudio } from "../utils/btnAudio";
import { IoArrowBackCircleSharp } from "react-icons/io5";
import { CButton } from "./CommonComponents";
import TextToSpeech from "./TextToSpeech";
import { IoSearchSharp } from "react-icons/io5";
import { extractDishTitle, removeFirstTitleLine } from "../utils/extractTitle";
import Layout from "./Layout";
import { updateUserTokensV2 } from "../utils/apiServices/usersService";
import { setShowNavigationWarning } from "../redux/ui-slice";
import { saveImageToStorageFunctionService } from "../utils/apiServices/firebaseImageStorageService";
import { setImage } from "../redux/image";

function RecipeDetails() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const moviesCollectionRef = collection(firestoredDB, "CookBook");

  const { title } = useSelector((state) => state.title);
  const { image } = useSelector((state) => state.image);
  const { prompt: recipePrompt } = useSelector((state) => state.recipe);
  const { dishNumber } = useSelector((state) => state.title);
  const { ingredients } = useSelector((state) => state.ingredients);
  const { instructions } = useSelector((state) => state.instructions);
  const [showImage, setShowImage] = useState(false);
  const { recipeTokens, dishTokens } = useSelector((state) => state.tokens);
  const abc = useSelector((state) => state.tokens);
  const {
    user: { uid },
  } = useSelector((state) => state.auth.user);
  const { shouldShowNavigationWarning } = useSelector((state) => state.uiSlice);
  console.log(shouldShowNavigationWarning, "shouldShowNavigationWarning");
  // const [title, setTitle] = useState("");
  const [history, setHistory] = useState([]);
  const [alreadySaved, setAlreadySaved] = useState(false);
  const contentRef = useRef(null);
  const [displayedText, setDisplayedText] = useState("");
  const [oldInstructions, setOldInstructions] = useState("");
  const [add, setAdd] = useState("Add To Cookbook");
  const [loading, setLoading] = useState(false);
  const [openAddToCookbookModal, setOpenAddToCookbookModal] = useState(false);
  const [listsData, setListsData] = useState([]);
  const [listDropDownOptions, setListDropDownOptions] = useState([]);
  const [selectedCookbookList, setSelectedCookbookList] = useState({ id: 1 });
  const [
    isRecipeDetailsFindVariantTriggered,
    setIsRecipeDetailsFindVariantTriggered,
  ] = useState(0);
  const {
    Culture,
    FreeFlow,
    IncludedIngredients,
    ExcludedIngredients,
    Description,
    Occasion,
    Language,
  } = ingredients;

  // let prompt2 = `Let's cook up something delicious! Please find me a ${Culture} dish ${FreeFlow? `that ${freeFlow}`:""}  ${
  //   IncludedIngredients
  //     ? `and  includes the ingredients ${IncludedIngredients}`
  //     : ""
  // },  ${
  //   ExcludedIngredients ? `but does not contain ${ExcludedIngredients}` : ""
  // }.  ${Description ? `It should be ${Description}` : ""}  ${
  //   Occasion ? `and be suit no able for ${Occasion}` : ""
  // }  ${Language ? `Please write the dish in ${Language}` : ""}`;

  let prompt2 = `Let's Cook Up Something Delicious!
    
    ###Please find me a ${Culture} dish ${
    IncludedIngredients ? `with ${IncludedIngredients}` : ""
  }${
    ExcludedIngredients
      ? `that and does not contain ${ExcludedIngredients}`
      : ""
  }. 
      ${Description ? ` should be ${Description}` : ""}  ${
    Occasion ? `and be suitable for ${Occasion}. ` : ""
  } ${FreeFlow ? FreeFlow + ". " : ""} ${
    Language ? `Please write the dish in ${Language}` : ""
  }`;

  let prompt3 = `Give me a professional food commercial image of ${title} plated and set against an appropriate backdrop. No Text. Focus mainly on the dish.
      image 
      ${
        IncludedIngredients
          ? `should includes the ingredients ${IncludedIngredients}`
          : ""
      },
      ${
        ExcludedIngredients ? `and does not contain ${ExcludedIngredients}` : ""
      }.
      ${Description ? `It should be ${Description}` : ""}  
      ${Occasion ? `and be suit no able for ${Occasion}` : ""} 
     `;

  // Add a new document in collection "recipes"
  const onSubmitRecipe = async () => {
    setOpenAddToCookbookModal(false);

    if (recipeTokens <= 0) {
      Swal.fire({
        icon: "info",
        title: "You are out of Recipe Tokens",
        showConfirmButton: true,
        timer: 2000,
      });
      return;
    }

    if (alreadySaved) {
      Swal.fire({
        icon: "info",
        title: "Recipe is Already Saved in the cookbook",
        showConfirmButton: false,
        timer: 1000,
      });
      return;
    }
    setAdd("Adding...");
    setLoading(true);

    // const { data } = await saveImageToStorage({ imageUrl: image });
    const data = await saveImageToStorageFunctionService(image);

    setAlreadySaved(true);
    dispatch(setShowNavigationWarning(false));
    try {
      const res = await addDoc(moviesCollectionRef, {
        userId: auth?.currentUser?.uid,
        title: title,
        description: instructions || null,
        ingredients: ingredients || null,
        imageUrl: data || null,
        // imageUrl: null,
        listId: selectedCookbookList?.id == 1 ? null : selectedCookbookList?.id,
        createdAt: serverTimestamp(),
      });

      Swal.fire({
        icon: "success",
        title: "Recipe added successfully",
        showConfirmButton: false,
        timer: 3000,
        confirmButtonColor: "#f0481a",
      });

      setAdd("Add To Cookbook");
      setLoading(false);
      const dbRes = await updateUserTokensV2(uid, "recipe");
      console.log(dbRes, "dbRes");
      if (dbRes) {
        dispatch(decreamentRecipeTokens());
      }

      // if (
      //   updateUserTokens(
      //     firestoredDB,
      //     collection,
      //     query,
      //     where,
      //     getDocs,
      //     updateDoc,
      //     doc,
      //     uid,
      //     "download"
      //   )
      // ) {
      //   dispatch(incrementDownloadTokens());
      // }
    } catch (err) {
      setLoading(false);

      Swal.fire({
        icon: "info",
        title: err.message,
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  const findVariant = () => {
    if (recipeTokens <= 0) {
      Swal.fire({
        icon: "info",
        title: "You are out of Recipe Tokens",
        showConfirmButton: true,
        timer: 2000,
      });

      return;
    }

    dispatch(emptyRecipeAllImageByDishNumber(dishNumber));
    dispatch(resetImageGenerationCount());
    dispatch(
      setDishImage({
        dishNumber,
        url: "",
      })
    );

    if (alreadySaved) {
      setAlreadySaved(false);
      dispatch(setShowNavigationWarning(true));
      dispatch(clearTitle());

      dispatch(setImage(""));
      console.log(dishNumber, "dishNumber");
      dispatch(emptyRecipeAllImageByDishNumber(dishNumber));
      dispatch(resetImageGenerationCount());
      dispatch(
        setDishImage({
          dishNumber,
          url: "",
        })
      );

      setHistory([
        ...history,
        {
          role: "user",
          content: recipePrompt,
        },
        {
          role: "system",
          content: instructions,
        },
        {
          role: "user",
          content:
            "Find a Variant. The response should be in detail as told. with a very short intro of dish.",
        },
      ]);
      return;
    }

    Swal.fire({
      title: "Leave Recipe?",
      text: "This Will Conclude Your Token",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Leave - Do Not Save",
      denyButtonText: `Leave - But Save Recipe`,
      showCloseButton: true,
      dangerMode: true,
    }).then(async (result) => {
      if (result.isDenied) {
        await onSubmitRecipe();
        setAlreadySaved(false);
        dispatch(setShowNavigationWarning(false));
        dispatch(clearTitle());
        dispatch(setImage(""));
        dispatch(emptyRecipeAllImageByDishNumber(dishNumber));
        dispatch(resetImageGenerationCount());
        dispatch(
          setDishImage({
            dishNumber,
            url: "",
          })
        );
        setHistory([
          ...history,
          {
            role: "user",
            content: recipePrompt,
          },
          {
            role: "system",
            content: instructions,
          },
          {
            role: "user",
            content:
              "Find a Variant. The response should be in detail as told. with a very short intro of dish.",
          },
        ]);

        dispatch(clearInstructions());
        setIsRecipeDetailsFindVariantTriggered(
          isRecipeDetailsFindVariantTriggered + 1
        );
        return;
      } else if (result.isConfirmed) {
        setAlreadySaved(false);
        dispatch(setShowNavigationWarning(false));

        dispatch(setImage(""));
        dispatch(emptyRecipeAllImageByDishNumber(dishNumber));
        dispatch(resetImageGenerationCount());
        dispatch(
          setDishImage({
            dishNumber,
            url: "",
          })
        );
        dispatch(clearTitle());
        setHistory([
          ...history,
          {
            role: "user",
            content: recipePrompt,
          },
          {
            role: "system",
            content: instructions,
          },
          {
            role: "user",
            content: "Find a Variant.",
          },
        ]);

        dispatch(clearInstructions());
        setIsRecipeDetailsFindVariantTriggered(
          isRecipeDetailsFindVariantTriggered + 1
        );
        return;
      } else {
        return;
      }
    });
  };

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = contentRef.current.scrollHeight;
    }
  }, [displayedText]);
  // useEffect(() => {
  //   setTimeout

  // }, []);

  const makeDropDownOptionsForListPopup = (lists) => {
    const options = [{ id: 1, name: "General" }];
    lists?.map((item, index) => {
      options?.push({
        id: item?.id,
        name: item?.name,
      });
    });
    setSelectedCookbookList(options[0]);
    setListDropDownOptions(options);
  };
  //Get Lists data
  const listCollectionRef = collection(firestoredDB, "Lists");

  const getLists = async () => {
    try {
      // const data = await getDocs(listCollectionRef);
      const data = await getDocs(listCollectionRef);
      const filteredData = data.docs
        .map((doc) => ({
          ...doc.data(),
          id: doc.id,
          createdAt: doc._document.createTime.timestamp.seconds,
        }))
        .sort((a, b) => a.createdAt - b.createdAt);

      const userData = filteredData.filter((item) => {
        return item.userId === auth?.currentUser?.uid;
      });
      makeDropDownOptionsForListPopup(userData);
      setListsData(userData);
    } catch (err) {
      console.error(err);
    }
  };

  const onAddToCookBookModalClick = async () => {
    playAudio();
    if (alreadySaved) {
      Swal.fire({
        icon: "info",
        title: "Recipe is Already Saved in the cookbook",
        showConfirmButton: false,
        timer: 2000,
      });
    } else {
      setOpenAddToCookbookModal(true);
      // setLoading(true);
      if (listDropDownOptions?.length == 0) {
        await getLists();
      }
    }
  };

  return (
    <section className=" ">
      <div className="">
        <div className="">
          {/* Background image */}
          <Layout>
            <article className="w-full mx-auto">
              {/* Article content */}
              <div ref={contentRef} className="text-lg  text-gray-400 w-full ">
                {displayedText !== "" ? (
                  <div className="flex justify-between flex-col md:flex-row gap-4 mb-4 ">
                    <div className="flex md:justify-center items-center gap-4 md:max-w-[75%]">
                      <button
                        onClick={async () => {
                          if (!alreadySaved) {
                            Swal.fire({
                              title: "Leave Recipe?",
                              text: "This Will Conclude Your Token",
                              icon: "warning",
                              showDenyButton: true,
                              confirmButtonText: "Leave - Do Not Save",
                              denyButtonText: `Leave - But Save Recipe`,
                              showCloseButton: false,
                              dangerMode: true,
                              allowEscapeKey: false,
                            }).then(async (result) => {
                              if (result.isDenied) {
                                await onSubmitRecipe();
                                navigate("/discover-dishes");
                              } else if (result.isConfirmed) {
                                navigate("/discover-dishes");
                              } else {
                                return;
                              }
                            });
                          } else {
                            navigate("/discover-dishes");
                          }
                        }}
                        className="cursor-pointer text-3xl text-white  "
                      >
                        <IoArrowBackCircleSharp size={50} className="" />
                      </button>
                      <span className="text-2xl font-bold dark:text-white text-[#3D3D3D]">
                        {extractDishTitle(title, 2)?.replaceAll("*", "")}
                      </span>
                    </div>

                    <div>
                      <CButton
                        // onClick={openModal}
                        onClick={onAddToCookBookModalClick}
                        disabled={loading}
                        className="
            "
                        variant="red"
                      >
                        {add}
                      </CButton>
                      {/* <CButton
                    // onClick={openModal}
                    // onClick={onAddToCookBookModalClick}
                    disabled={loading}
                    className="
            "
                    variant="skin"
                  >
                    <TextToSpeech displayedText={displayedText} />
                  </CButton> */}
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}

                <figure className=" flex justify-center">
                  {prompt3 && (
                    <GenerateImageRecipe
                      prompt={prompt3}
                      isRecipeDetailsFindVariantTriggered={
                        isRecipeDetailsFindVariantTriggered
                      }
                    />
                  )}
                </figure>
                <div className="">
                  <GenerateInstructions
                    prompt={prompt2}
                    title={title}
                    history={history ? history : null}
                    displayedText={removeFirstTitleLine(displayedText)}
                    setDisplayedText={setDisplayedText}
                    oldInstructions={oldInstructions}
                    setOldInstructions={setOldInstructions}
                  />
                </div>
                {displayedText !== "" ? (
                  <div className="mt-4 flex w-full gap-4 flex-col md:flex-row ">
                    <CButton
                      variant="red"
                      type="button"
                      className="w-full"
                      onClick={async () => {
                        playAudio();
                        if (!alreadySaved) {
                          Swal.fire({
                            title: "Leave Recipe?",
                            text: "This Will Conclude Your Token",
                            icon: "warning",
                            showDenyButton: true,
                            confirmButtonText: "Leave - Do Not Save",
                            denyButtonText: `Leave - But Save Recipe`,
                            showCloseButton: true,
                            dangerMode: true,
                          }).then(async (result) => {
                            dispatch(setShowNavigationWarning(false));
                            if (result.isDenied) {
                              await onSubmitRecipe();
                              navigate("/discover-dishes");
                            } else if (result.isConfirmed) {
                              navigate("/discover-dishes");
                            } else {
                              return;
                            }
                          });
                        } else {
                          navigate("/discover-dishes");
                        }
                      }}
                    >
                      <IoSearchSharp className="text-xl mr-2 font-bold" />
                      Start Fresh
                    </CButton>
                    <CButton
                      variant="red"
                      type="button"
                      // onClick={openModal}
                      onClick={onAddToCookBookModalClick}
                      disabled={loading}
                      className="w-full
                                "
                    >
                      {add}
                    </CButton>
                    <CButton
                      type="button"
                      variant="orange"
                      onClick={() => {
                        playAudio();
                        findVariant();
                      }}
                      className="w-full
           "
                    >
                      Find Varient
                    </CButton>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            </article>

            {/* <div className="fixed flex md:space-x-3 md:flex-row flex-col w-fit left-0 right-0 z-90 bottom-2 md:bottom-4 m-auto">
            <div className="flex space-x-2 justify-center items-center ">

              <CButton
                type="button"
                variant="orange"
                onClick={() => {
                  playAudio();
                  findVariant();
                }}
                className="
           "
              >
                Find Varient
              </CButton>
            </div>
            <div className="flex space-x-2 justify-center items-center">
              <CButton
                variant="red"
                type="button"
                onClick={async () => {
                  playAudio();
                  if (!alreadySaved) {
                    Swal.fire({
                      title: "Leave Recipe?",
                      text: "This Will Conclude Your Token",
                      icon: "warning",
                      showDenyButton: true,
                      confirmButtonText: "Leave - Do Not Save",
                      denyButtonText: `Leave - But Save Recipe`,
                      showCloseButton: true,
                      dangerMode: true,
                    }).then(async (result) => {
                      if (result.isDenied) {
                        await onSubmitRecipe();
                        navigate("/discover-dishes");
                      } else if (result.isConfirmed) {
                        navigate("/discover-dishes");
                      } else {
                        return;
                      }
                    });
                  } else {
                    navigate("/discover-dishes");
                  }
                }}
                className="
           "
              >
                Start Fresh
              </CButton>
            </div>
          </div> */}
            {/* </div> */}
          </Layout>
        </div>
      </div>
      <AddToCookbookModal
        isOpen={openAddToCookbookModal}
        onDoneClick={() => onSubmitRecipe()}
        onCloseClick={() => setOpenAddToCookbookModal(false)}
        listDropDownOptions={listDropDownOptions}
        selectedOption={selectedCookbookList}
        setSelectedOption={setSelectedCookbookList}
      />
    </section>
  );
}

export default RecipeDetails;
